import VModel from '@/vuetify_custom/v-modal_v1'
import VForm from '@/vuetify_custom/v-form'
import { formattingNumber } from '@/libs/util'
import Number_Field from '@/vuetify_custom/v-form/components/Number_Field.js'
import AutocompletesAsync from '@/vuetify_custom/v-form/components/Autocompletes_Async_v1.js'
import {verifyIllegality} from './utils'
import { pre_to, initThridData } from './fields'
import { saveThirdPartyShopApi } from './services'


export default {
    data() {
        return {
            dis: false,
            params: initThridData(),
            apply_user_list:[],
            principal_list: [],
            preparer_list: [],
            account_payee_list: [],
            payee_company_id_hash: {},
            docking_people_list: [],
            manager_name_list: [],
            submitLoading:false
        }
    },
    computed: {
        materialsListHash() {
            return this.$store.getters['async/opening_shop_materials_hash'] || []
        },
        openshopInfor() {
            const _this = this
           const arr = [
               {
                   label: '店铺名称',
                   key: 'shop_name',
                   cols: 8,
                   required: true
               },
            {
                label: '商城编号/苹果bundleID',
                key: 'mall_code',
                cols: 8,
            },
           {
               label: '开店公司主体',
               type: 'company_select',
               key: 'company_id',
               cols: 8,
               required: true,
               rules: [val => {
                   return !!val || '开店公司主体必选'
               }],
               change(data, target = {}) {
                   _this.params.company_name = target.name
               }
           },
            {
                label: '押金',
                type:'number_field',
                key: 'deposit',
                d_digits:2,
                'persistent-hint': true,
                placeholder: '没有则不填',
                cols: 8,
                suffix: '元'          
            },
            {
                label: '认证款',
                type:'number_field',
                key: 'certification_cost',
                'persistent-hint': true,
                d_digits:2,
                placeholder: '没有则不填',
                cols:  8,
                suffix: '元'
            },
            {
                label: '财务子账号信息',
                key: 'sub_account_info',
                cols: 8,
                type: 'textareas_field',
                rows: 3,
                hint: "请补充财务子账号名称及密码信息，若没有则请填写“无”",
                'persistent-hint': true
            },
            {
                label: '店铺负责人',
                key:'principal_id',
                type:'autocompletes_async_v1',
                'item-value':'id',
                'item-text':'account',
                api: this.$util.api.customer_select_search,
                initList: this.principal_list,
                cols: 8,
                required: true,
                rules:[val => {
                    return !verifyIllegality(val) || '必选'
                  }],
                handle_data:({customers}) => {
                    return customers
                 // this.principal_list = customers
                },
                change(data, target) {
                    if (!target) {
                        _this.params.principal_name = null
                        return 
                    }
                    _this.params.principal_name = target.account
               
                }
            },
            {
                label: '店铺实际管理人',
                key:'manager_id',
                type:'autocompletes_async_v1',
                'item-value':'id',
                'item-text':'account',
                api: this.$util.api.customer_select_search,
                initList: this.manager_name_list,
                cols: 8,
                required: true,
                rules:[val => {
                    return !verifyIllegality(val) || '必选'
                  }],
                handle_data:({customers}) => {
                    return customers
                 // this.principal_list = customers
                },
                change(data, target) {
                    if (!target) {
                        _this.params.manager_name = null
                        return 
                    }
                     _this.params.manager_name = target.account
                   
                }
            },
            {
                label: '平台分成比例（单位：%）',
                type:'number_field',
                key: 'sharing_percent',
                cols: 8,
                required: true,
                rules:[val => {
                    return !verifyIllegality(val) || '平台分成比例必填'
                  }],
            },
            {
                label: '收款手续费比例（单位：%）',
                type:'number_field',
                key: 'fee_percent',
                cols: 8,
                required: true,
                rules:[val => {
                    return !verifyIllegality(val) || '收款手续费比例必填'
                  }],
            },
            {
                label: '结算方式',
                key: 'payment_means',
                cols: 8,
                required: true,
                rules:[val => {
                    return !!val || '结算方式必填'
                  }],
            },
            {
                label: '对账频率',
                key: 'frequency',
                cols: 8,
                required: true,
                rules:[val => {
                    return !!val || '对账频率必填'
                  }],
            },
            { 
                label: '收款账户',
                key:'payee_company_account_id',
                type:'autocompletes_async_v1',
                'item-value':'id',
                api: this.$util.api.payee_company_account_select_search,
                'item-text':'text_name',
                placeholder: '与开店主体的对应银行一致',
                initList: this.account_payee_list,
                cols: 8,
                required: true,
                rules: [val => {
                  return !!val || '收款账户必选'
                }],
                handle_data:({accounts}) => {
                  accounts && accounts.forEach(account => {
                   this.payee_company_id_hash[account.id] = account
                  });
                  return accounts.map(item => ({
                    ...item,
                    text_name: `${item.bank_number}-${item.bank_account}-${item.bank}`
                  }))
             
                },
                change:(data, target = {}) => {     
                    if (_this.account_payee_list && !_this.account_payee_list.some(item => item.id === target.id)) {
                        _this.account_payee_list.push(target)
                    } 
         
                 const current = this.payee_company_id_hash[data]
                 pre_to.forEach(([pre, cur]) => {
                  this.params[cur] = current && current[pre] || null
                 })
                }
              },
              {
                label: '收款对接人',
                key:'payee_user_id',
                type:'autocompletes_async_v1',
                'item-value':'id',
                'item-text':'account',
                placeholder: '应为开店负责人',
                api: this.$util.api.customer_select_search,
                initList: this.docking_people_list,
                cols: 8,
                required: true,
                rules: [val => {
                  return !!val || '收款对接人必选'
                }],
                handle_data:({customers}) => {
                    return customers
                },
                change(data, target = {}) {

                    // if (_this.docking_people_list && !_this.docking_people_list.some(item => item.id === target.id)) {
                    //     _this.docking_people_list.push(target)
                    // } 
                    _this.params.payee_user = target.account
                }
              },
              {
                label: '开票主体',
                key: 'invoice_company_id',
                type:'company_select',
                cols: 8,
                placeholder: '请联系税务吴荔老师确认开票主体',
                required: true,
                rules: [val => {
                    return !!val || '开票主体必选'
                  }],
                  change(data, target = {}) {
                  
                     _this.params.invoice_company_name = target.short_name
                }
              },
              {
                label: '售卖类型',
                type: 'select_field',
                'item-text': 'label',
                 key: 'sale_type',
                 cols:  8,
                    items: [
                        {
                            label: '实体商品',
                            value: 'reality'
                        },
                        {
                            label: '课程',
                            value: 'course'
                        },
                        {
                            label: '会员',
                            value: 'member'
                        },
                        {
                            label: '其他',
                            value: 'other'
                        }
                    ],
                    required: true,
                    rules: [val => {
                        return !!val || '售卖类型必选'
                    }],
              },
              {
                // $_not_dis:this.params.sale_type !== 'other',
                label: '商品描述',
                key: 'sale_type_other',
                type: 'textareas_field',
                cols: 8,
                rows: 3,
                rules:[val => {
                    if (this.params.sale_type === 'other') {
                        if (typeof val === 'string') {
                            val = val.trim()
                        }
                        return !!val || '[售卖类型-其他]必填'
                    }
                    return true
                }],
            },
              
            ]
            return arr
        },
    },
    methods: {
        cancel() {
            this.dis = false
            this.params = initThridData()
            setTimeout(() => {
                ['open_shop'].forEach(key => {
                    this.$refs[key].resetValidation()
                })
            }, 100)
        },
        show(data) {
           if (data) {
               data = JSON.parse(JSON.stringify(data))
               const params_init = initThridData()
               Object.keys(params_init).forEach(key => {
                params_init[key] = data[key]
               })
               this.docking_people_list = [{
                    id: data.payee_user_id,
                    account: data.payee_user,
                }]  
                            this.docking_people_list = [{
                        id: this.params.payee_user_id,
                        account: this.params.payee_user,
                    }]   
                    const account_payee_obj = {}
                              pre_to.forEach(item => {
                        account_payee_obj[item[0]] = data[item[1]]
                    })
                    account_payee_obj.text_name = `${account_payee_obj.bank_number}-${account_payee_obj.bank_account}-${account_payee_obj.bank}`
                    this.account_payee_list = [account_payee_obj]
               this.params = params_init
                // console.log('this.params.sale_type', this.params.sale_type)
                // getApplyOpenShopDetailApi(data).then(res => {
                //     const account_payee_obj = {}
                //     this.params = initThridData()
                //     const iniCurrent = initThridData()
                //     Object.keys(iniCurrent).forEach(key => {
                //         this.params[key] = res[key] || iniCurrent[key]
                //     })
                //     this.params.uid = res.uid
                   
                //     this.params.refund_at = moment(res.refund_at).format(DATE_DAY_FORMATE)
                //     /* 填表人 */
                //     CustomerUtil.briefInfo(this.params.customer_id).then(fill_customer => {
                //         this.preparer_list.push(fill_customer)
                //     }) 
                //     this.params.fill_customer_id = res.fill_customer_id
                //     /* 店铺负责人列表 */
                //     this.principal_list = res.principal_id && [
                //         {
                //             id: res.principal_id,
                //             account:res.principal_name || '-',
                //         }
                //     ] || []
                //     /* 收款账户列表 */
                //     pre_to.forEach(item => {
                //         account_payee_obj[item[0]] = res[item[1]]
                //     })
                //     account_payee_obj.text_name = `${account_payee_obj.bank_number}-${account_payee_obj.bank_account}-${account_payee_obj.bank}`
                //     this.account_payee_list = [account_payee_obj]
                //      /* 收款对接人 */
                //     this.docking_people_list = [{
                //         id: this.params.payee_user_id,
                //         account: this.params.payee_user,
                //     }]   
                // })
                     this.principal_list = data.principal_id && [
                        {
                            id: data.principal_id,
                            account:data.principal_name || '-',
                        }
                    ] || []
                    this.manager_name_list = data.manager_id && [
                        {
                            id: data.manager_id,
                            account:data.manager_name || '-',
                        }
                    ] || []
            } else {
                const cur_customer = this.$store.state.cur_customer
                this.params = initThridData()
                this.params.customer_id = cur_customer.id
                this.apply_user_list = [
                    {
                        id: cur_customer.id,
                        account: cur_customer.account
                    }
                ]
                this.preparer_list = [{
                    id: cur_customer.id,
                    account: cur_customer.account
                }]
                this.params.fill_customer_id = cur_customer.id
            }
            this.dis = true
        },
        editOk() {
            if (this.validate()) {
                const params_clone = JSON.parse(JSON.stringify(this.params))
                this.submitLoading = true
                saveThirdPartyShopApi(params_clone).then((res) => {
                    this.$Message.success({
                        content: '编辑成功！'
                    })
                    this.$emit('success', res)
                    this.cancel()
                }).finally(() => {
                    this.submitLoading = false
                })
            }  
        },
        validate() {
            return this.$refs['open_shop'].validate()
           // return ['open_shop'].map(item => this.$refs[item].validate()).every(item => item)
          }
    },
    render() {
        const _this = this
        return <VModel
            v-model={_this.dis}
            persistent
            dynamic-height
            title="第三方店铺"
            max-width="750"
            loading={_this.submitLoading}
            on={{
                ok: _this.editOk,
                cancel: _this.cancel
            }}
           
        >
            <div style={{
                margin: '0 20px'
            }}>
                    <VForm
                            ref="open_shop"
                            v-model={_this.params}
                            fields={_this.openshopInfor}
                            scopedSlots={{
                                payee_user_id:({field}) => {
                                    return <AutocompletesAsync
                                        v-model={_this.params}
                                        field={field}
                                    />
                                },
                                // AutocompletesAsync
                                manager_id:({field}) => {
                                    return <AutocompletesAsync
                                        v-model={_this.params}
                                        field={field}
                                    />
                                },
                                principal_id:({field}) => {
                                    return <AutocompletesAsync
                                        v-model={_this.params}
                                        field={field}
                                    />
                                },
                                deposit:({field}) => {
                                    return <Number_Field
                                        field={{
                                            ...field,
                                            hint: _this.params.deposit && formattingNumber(this.params.deposit, 2) || ''
                                        }}
                                        value={_this.params}
                                    />
                                },
                                certification_cost: ({field}) => {
                                    return <Number_Field
                                        field={{
                                            ...field,
                                            hint: _this.params.certification_cost && formattingNumber(this.params.certification_cost, 2) || ''
                                        }}
                                        value={_this.params}
                                    />
                                },

                            }}
                        />
            </div>
         </VModel>
    }
}